<template>
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="page-title mb-0 font-size-18 text-capitalize">{{title}}</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li v-for="(v,k) in breadcrumbs" v-bind:key="k" 
            class="breadcrumb-item" v-bind:class="{active: k===(breadcrumbs.length-1)}">{{v}}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AppPageTitle',
  props: {
    title: {
      type: String,
      default: ""
    },
    breadcrumbs:{
        type: Array,
        default: () => []
    }
  }
};
</script>